import React, { useState, useEffect } from "react";
import "./index.scss";
import { Chart } from "react-google-charts";
import LoaderUI from "../loader";
const BarGraph = ({ barColor, data, loading }) => {
  const options = {
    colors: `${barColor}`,
    bar: { groupWidth: "50%" },
    legend: { position: "none" }
  };
  const [isLoading, setIsLoading] = useState(loading);
  useEffect(() => {
    setIsLoading(loading)
  }, [loading]);

  return (
    <>
      {isLoading ? <LoaderUI FullWindow={false} inContainer /> :
        <Chart
          onLoad={() => setIsLoading(false)}
          chartType="Bar"
          width="100%"
          height="100%"
          data={data}
          options={options}
        />
      }
    </>
  );
};
export default BarGraph;
